import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';



const CargarRegistros=({ id, ajaxCallInProgress, errors=[],  strings, onChange, onChangeAdjunto, cargarInformacion })=>{

    
	return (
        <Container>
            <Header  dividing>
            <Header.Content>{strings?strings["CargarConstanciasExternas"]:""}</Header.Content>
          </Header>
             <Form  >    
                 <Form.Field  >  
                 <label  >Seleccionar archivo de carga:</label>
                <Input   
                    placeholder='adjunto' 
                    type='file'
                    name='adjunto'
                    onChange={onChangeAdjunto}
                    />
                </Form.Field>
             </Form>        
            <br/><br/>
            
            <Button fluid color="black" onClick={ cargarInformacion}>
                <Icon name='cloud upload' color="green" />
            Cargar archivo de constancias</Button>
        
        
        </Container>
	);
};



export default CargarRegistros;